import React from 'react';
import { Package } from 'lucide-react';
import { useApkBuild } from '../hooks/useApkBuild';
import { useNetworkDebug } from '../hooks/useNetworkDebug';
import { EmulatorsSection } from '../components/buildApk/EmulatorsSection';
import { BuildCards } from '../components/buildApk/BuildCards';
import { NetworkMonitor } from '../components/buildApk/NetworkMonitor';

export const BuildApkPage: React.FC = () => {
  const {
    debugLog,
    networkInfo,
    autoRefresh,
    setAutoRefresh,
    setDebugLog,
    fetchNetworkDebug,
  } = useNetworkDebug();

  const {
    buildingFlutter,
    flutterOutput,
    flutterStatus,
    buildFlutterApk,
    buildingReact,
    reactOutput,
    reactStatus,
    reactProgress,
    buildReactApk,
    downloadApk,
  } = useApkBuild(fetchNetworkDebug);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 p-4">
      <div className="max-w-[1800px] mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-3 mb-4">
            <Package className="w-12 h-12 text-blue-600" />
            <h1 className="text-4xl font-bold text-gray-800">
              Gerador de APKs
            </h1>
          </div>
          <p className="text-gray-600 text-lg">
            Gere aplicativos Android para Flutter e React Native
          </p>
        </div>

        {/* Emulators Section */}
        <EmulatorsSection />

        {/* Main Grid: Build Cards + Debug Terminal */}
        <div className="grid lg:grid-cols-3 gap-6">
          <BuildCards
            flutter={{
              building: buildingFlutter,
              status: flutterStatus,
              output: flutterOutput,
              onBuild: buildFlutterApk,
              onDownload: () => downloadApk('flutter'),
            }}
            react={{
              building: buildingReact,
              status: reactStatus,
              progress: reactProgress,
              output: reactOutput,
              onBuild: buildReactApk,
              onDownload: () => downloadApk('react'),
            }}
          />

          {/* Right Side: Debug Terminal (1/3 width) */}
          <div className="lg:col-span-1">
            <NetworkMonitor
              debugLog={debugLog}
              networkInfo={networkInfo}
              autoRefresh={autoRefresh}
              onToggleAutoRefresh={() => setAutoRefresh(!autoRefresh)}
              onRefresh={fetchNetworkDebug}
              onClearLog={() => setDebugLog('🔧 Log limpo\n')}
            />
          </div>
        </div>

        {/* Back Button */}
        <div className="text-center mt-6">
          <a
            href="/selection"
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-600 text-white rounded-lg hover:bg-gray-700 transition-all duration-300"
          >
            ← Voltar para Seleção
          </a>
        </div>
      </div>
    </div>
  );
};
